import React, { useState, useEffect, useCallback } from 'react';
import { rdvAPI } from '../services/api';
import { makeCall } from '../services/sipClient';

function timeLabel(rdvDate, rdvTime) {
  if (!rdvDate) return { label: '—', overdue: false };
  const str = `${rdvDate} ${rdvTime || '00:00'}`;
  const d   = new Date(str);
  const now = new Date();
  const ms  = d - now;
  const abs = Math.abs(ms);
  const m   = Math.floor(abs / 60000);
  const h   = Math.floor(abs / 3600000);
  const dy  = Math.floor(abs / 86400000);
  if (ms < -60000)   return { label: h < 24 ? `${h}h en retard` : `${dy}j en retard`, overdue: true };
  if (ms < 0)        return { label: 'Maintenant !', overdue: true, now: true };
  if (m < 60)        return { label: `dans ${m} min`, overdue: false };
  if (h  < 24)       return { label: `dans ${h} h`, overdue: false };
  const [dt, tm] = str.split('T');
  const [,mo,day] = (dt||'').split('-');
  const months = ['Jan','Fév','Mar','Avr','Mai','Juin','Juil','Août','Sep','Oct','Nov','Déc'];
  return { label: `${day} ${months[parseInt(mo)-1]} ${tm?.slice(0,5)}`, overdue: false };
}

function fmtDate(rdvDate, rdvTime) {
  if (!rdvDate) return '—';
  const [y, mo, day] = (rdvDate||'').split('-');
  const months = ['Jan','Fév','Mar','Avr','Mai','Juin','Juil','Août','Sep','Oct','Nov','Déc'];
  return `${day} ${months[parseInt(mo)-1]} ${y}  ${rdvTime ? rdvTime.slice(0,5) : ''}`;
}

function DetailModal({ rdv, onClose, onCall, onDismiss }) {
  const name = [rdv.client_first, rdv.client_last].filter(Boolean).join(' ') || 'Inconnu';
  const time = timeLabel(rdv.rdv_date, rdv.rdv_time);
  const statutLabel = rdv.statut === 'no_show' ? 'No-show' : 'Refus';
  const statutColor = rdv.statut === 'no_show' ? '#ef4444' : '#dc2626';

  return (
    <div style={{ position:'fixed', inset:0, zIndex:4000, background:'rgba(30,18,72,0.6)', display:'flex', alignItems:'center', justifyContent:'center', padding:20, backdropFilter:'blur(10px)' }}
      onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background:'#fff', borderRadius:20, width:460, maxHeight:'88vh', overflow:'auto', boxShadow:'0 32px 80px rgba(124,58,237,0.3)' }}>
        <div style={{ padding:'18px 20px', background:`linear-gradient(135deg,${statutColor},#dc2626)`, borderRadius:'18px 18px 0 0' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
            <div>
              <div style={{ fontSize:10, fontWeight:800, textTransform:'uppercase', letterSpacing:'0.1em', color:'rgba(255,255,255,0.7)', marginBottom:3 }}>📞 No-show / Refus</div>
              <div style={{ fontSize:20, fontWeight:900, color:'#fff' }}>{name}</div>
              <div style={{ fontFamily:'var(--mono)', fontSize:20, fontWeight:700, color:'rgba(255,255,255,0.9)', letterSpacing:2, marginTop:3 }}>{rdv.phone}</div>
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={{ padding:'4px 12px', borderRadius:100, fontSize:11, fontWeight:800, background: time.overdue?'rgba(239,68,68,0.35)':'rgba(255,255,255,0.2)', color:time.overdue?'#fca5a5':'#fff', border:`2px solid ${time.overdue?'rgba(239,68,68,0.5)':'rgba(255,255,255,0.35)'}`, marginBottom:4 }}>
                {time.overdue?'🔴':'🕐'} {time.label}
              </div>
              <div style={{ fontSize:11, color:'rgba(255,255,255,0.65)' }}>{fmtDate(rdv.rdv_date, rdv.rdv_time)}</div>
            </div>
          </div>
        </div>
        <div style={{ padding:20 }}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px 20px', marginBottom:16 }}>
            {[['Statut',statutLabel],['Conseiller',rdv.advisor_name],['Agent',rdv.agent_name],['Campagne ID',rdv.campaign_id]].filter(([,v])=>v).map(([l,v])=>(
              <div key={l}><div style={{ fontSize:9,fontWeight:800,textTransform:'uppercase',letterSpacing:'0.07em',color:'var(--text2)',marginBottom:2 }}>{l}</div><div style={{ fontSize:13,fontWeight:600,color:'var(--text)' }}>{v}</div></div>
            ))}
          </div>
          {rdv.comments && <div style={{ marginBottom:16,padding:'12px 14px',background:'rgba(124,58,237,0.06)',borderRadius:10,borderLeft:'3px solid var(--purple)' }}>
            <div style={{ fontSize:9,fontWeight:800,textTransform:'uppercase',letterSpacing:'0.08em',color:'var(--purple)',marginBottom:6 }}>📝 Notes</div>
            <div style={{ fontSize:13,color:'var(--text)',lineHeight:1.6 }}>{rdv.comments}</div>
          </div>}
          <div style={{ display:'flex',gap:10 }}>
            <button onClick={()=>onCall(rdv)} style={{ flex:1,height:46,borderRadius:100,border:'none',cursor:'pointer',background:'linear-gradient(135deg,#10b981,#06b6d4)',color:'#fff',fontSize:14,fontWeight:800,boxShadow:'0 6px 18px rgba(16,185,129,0.4)',transition:'all 0.2s' }}
              onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-2px)';e.currentTarget.style.boxShadow='0 10px 24px rgba(16,185,129,0.5)'}}
              onMouseLeave={e=>{e.currentTarget.style.transform='none';e.currentTarget.style.boxShadow='0 6px 18px rgba(16,185,129,0.4)'}}>
              📞 APPELER MAINTENANT
            </button>
            <button onClick={()=>onDismiss(rdv.id)} style={{ height:46,padding:'0 18px',borderRadius:100,border:'2px solid rgba(239,68,68,0.3)',background:'rgba(239,68,68,0.06)',color:'#dc2626',fontSize:13,fontWeight:700,cursor:'pointer' }}>🗑 Ignorer</button>
            <button onClick={onClose} style={{ height:46,padding:'0 16px',borderRadius:100,border:'2px solid var(--border)',background:'transparent',color:'var(--text2)',fontSize:13,fontWeight:600,cursor:'pointer' }}>Fermer</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function NoShowList({ sipConfig, refreshTrigger }) {
  const [rdvs, setRdvs]         = useState([]);
  const [open, setOpen]         = useState(false);
  const [detail, setDetail]     = useState(null);
  const [loading, setLoading]   = useState(true);

  const load = useCallback(async () => {
    try {
      const rows = await rdvAPI.noShow();
      setRdvs(Array.isArray(rows) ? rows : []);
    } catch(err) {
      console.error('[NoShow] load error:', err);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); const iv = setInterval(load, 20000); return () => clearInterval(iv); }, [load]);
  useEffect(() => { if (refreshTrigger > 0) { setTimeout(load, 1000); } }, [refreshTrigger, load]);

  const handleCall = (rdv) => {
    makeCall(rdv.phone, sipConfig);
    setRdvs(p => p.filter(r => r.id !== rdv.id));
    setDetail(null); setOpen(false);
  };

  const handleDismiss = (id) => {
    setRdvs(p => p.filter(r => r.id !== id));
    setDetail(null);
  };

  return (
    <>
      {/* ── Fixed tab at bottom-right ── */}
      <div onClick={() => setOpen(true)} style={{
        padding:'11px 16px', flexShrink:0, cursor:'pointer',
        background: rdvs.length > 0 ? 'linear-gradient(135deg,#ef4444,#dc2626)' : 'linear-gradient(135deg,#10b981,#06b6d4)', color:'#fff',
        display:'flex', alignItems:'center', justifyContent:'space-between',
        userSelect:'none', transition:'all 0.2s',
      }}
        onMouseEnter={e => e.currentTarget.style.filter='brightness(1.1)'}
        onMouseLeave={e => e.currentTarget.style.filter='none'}
      >
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <span style={{ fontSize:15 }}>📞</span>
          <span style={{ fontSize:11, fontWeight:800, textTransform:'uppercase', letterSpacing:'0.1em' }}>No-show</span>
          {rdvs.length > 0 && (
            <span style={{ background:'rgba(255,255,255,0.3)', color:'#fff', borderRadius:100, padding:'2px 9px', fontSize:12, fontWeight:900 }}>{rdvs.length}</span>
          )}
        </div>
        <span style={{ fontSize:12, opacity:0.8 }}>▲ Ouvrir</span>
      </div>

      {/* ── Full-screen overlay popup ── */}
      {open && (
        <div style={{ position:'fixed', inset:0, zIndex:3000, display:'flex', alignItems:'flex-end', justifyContent:'flex-end' }}
          onClick={e => e.target === e.currentTarget && setOpen(false)}>

          <div style={{ position:'absolute', inset:0, background:'rgba(30,18,72,0.3)', backdropFilter:'blur(4px)' }} onClick={() => setOpen(false)} />

          <div style={{
            position:'relative', zIndex:1,
            width:400, height:'100vh',
            background:'#fff',
            boxShadow:'-12px 0 48px rgba(124,58,237,0.2)',
            display:'flex', flexDirection:'column',
            animation:'slideInRight 0.25s cubic-bezier(.34,1.56,.64,1)',
          }}>
            <div style={{ padding:'18px 20px', background:'linear-gradient(135deg,#dc2626,#ef4444)', color:'#fff', flexShrink:0 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6 }}>
                <div style={{ fontSize:18, fontWeight:900, letterSpacing:'-0.5px' }}>📞 No-show / Refus</div>
                <button onClick={() => setOpen(false)} style={{ background:'rgba(255,255,255,0.2)', border:'none', borderRadius:10, width:32, height:32, cursor:'pointer', fontSize:16, color:'#fff', display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
              </div>
              <div style={{ display:'flex', gap:10, alignItems:'center' }}>
                <span style={{ fontSize:12, color:'rgba(255,255,255,0.75)', fontWeight:600 }}>{rdvs.length} en attente</span>
                <button onClick={load} style={{ marginLeft:'auto', background:'rgba(255,255,255,0.15)', border:'none', borderRadius:8, padding:'4px 10px', cursor:'pointer', color:'#fff', fontSize:11, fontWeight:700 }}>↻ Rafraîchir</button>
              </div>
            </div>

            <div style={{ flex:1, overflow:'auto' }}>
              {loading ? (
                <div style={{ padding:50, textAlign:'center', color:'var(--text2)', fontSize:14 }}>Chargement...</div>
              ) : rdvs.length === 0 ? (
                <div style={{ padding:50, textAlign:'center' }}>
                  <div style={{ fontSize:56, marginBottom:12, opacity:0.2 }}>📭</div>
                  <div style={{ fontSize:16, fontWeight:800, color:'var(--text)', marginBottom:6 }}>Aucun client à rappeler</div>
                  <div style={{ fontSize:13, color:'var(--text2)' }}>Les RDV « no-show » et « refus » apparaissent ici<br/>pour que vous puissiez les rappeler.</div>
                </div>
              ) : rdvs.map(rdv => {
                const name = [rdv.client_first, rdv.client_last].filter(Boolean).join(' ') || 'Inconnu';
                const time = timeLabel(rdv.rdv_date, rdv.rdvTime || rdv.rdv_time);

                return (
                  <div key={rdv.id} style={{ padding:'14px 18px', borderBottom:'2px solid var(--border)', background: time.overdue?'rgba(239,68,68,0.03)':'#fff' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:10 }}>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
                          <div style={{ width:9, height:9, borderRadius:'50%', background: rdv.statut === 'no_show' ? '#ef4444' : '#dc2626', flexShrink:0, boxShadow:`0 0 0 3px ${rdv.statut === 'no_show' ? 'rgba(239,68,68,0.2)' : 'rgba(220,38,38,0.2)'}` }} />
                          <span style={{ fontFamily:'var(--mono)', fontSize:16, fontWeight:800, color:'var(--purple)' }}>{rdv.phone}</span>
                        </div>
                        <div style={{ fontSize:13, fontWeight:700, color:'var(--text)', marginBottom:3, paddingLeft:17 }}>{name}</div>
                        <div style={{ fontSize:11, color:'var(--text2)', paddingLeft:17, marginBottom:3 }}>📅 {fmtDate(rdv.rdv_date, rdv.rdv_time)}</div>
                        {rdv.advisor_name && <div style={{ fontSize:11, color:'var(--purple)', paddingLeft:17, fontWeight:600 }}>👔 {rdv.advisor_name}</div>}
                        {rdv.comments && <div style={{ fontSize:12, color:'var(--text2)', paddingLeft:17, marginTop:5, padding:'6px 10px 6px 17px', background:'rgba(124,58,237,0.05)', borderRadius:8, borderLeft:'2px solid rgba(124,58,237,0.2)', fontStyle:'italic' }}>💬 {rdv.comments}</div>}
                      </div>
                      <div style={{ display:'flex', flexDirection:'column', gap:6, flexShrink:0, alignItems:'flex-end' }}>
                        <span style={{ fontSize:11, fontWeight:800, color:time.overdue?'#dc2626':'#d97706', padding:'3px 10px', borderRadius:100, background:time.overdue?'rgba(239,68,68,0.1)':'rgba(245,158,11,0.1)', border:`2px solid ${time.overdue?'rgba(239,68,68,0.25)':'rgba(245,158,11,0.25)'}` }}>
                          {time.label}
                        </span>
                        <button onClick={() => handleCall(rdv)} style={{
                          height:32, padding:'0 14px', borderRadius:100, border:'none', cursor:'pointer',
                          background:'linear-gradient(135deg,#10b981,#06b6d4)', color:'#fff',
                          fontSize:12, fontWeight:800, letterSpacing:'0.03em',
                          boxShadow:'0 4px 12px rgba(16,185,129,0.35)',
                          transition:'all 0.2s',
                        }}
                          onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-1px)';e.currentTarget.style.boxShadow='0 6px 16px rgba(16,185,129,0.45)'}}
                          onMouseLeave={e=>{e.currentTarget.style.transform='none';e.currentTarget.style.boxShadow='0 4px 12px rgba(16,185,129,0.35)'}}
                        >
                          📞 Appeler
                        </button>
                        <button onClick={() => setDetail(rdv)} style={{
                          height:28, padding:'0 12px', borderRadius:100,
                          border:'2px solid rgba(124,58,237,0.25)', background:'rgba(124,58,237,0.06)',
                          color:'var(--purple)', fontSize:11, fontWeight:700, cursor:'pointer', transition:'all 0.15s'
                        }}
                          onMouseEnter={e=>e.currentTarget.style.background='rgba(124,58,237,0.12)'}
                          onMouseLeave={e=>e.currentTarget.style.background='rgba(124,58,237,0.06)'}
                        >
                          Détails →
                        </button>
                        <button onClick={() => handleDismiss(rdv.id)} style={{
                          height:26, padding:'0 10px', borderRadius:100,
                          border:'2px solid rgba(239,68,68,0.2)', background:'transparent',
                          color:'#ef4444', fontSize:10, fontWeight:700, cursor:'pointer', transition:'all 0.15s'
                        }}
                          onMouseEnter={e=>e.currentTarget.style.background='rgba(239,68,68,0.06)'}
                          onMouseLeave={e=>e.currentTarget.style.background='transparent'}
                        >
                          🗑 Ignorer
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={{ padding:'12px 18px', borderTop:'2px solid var(--border)', background:'rgba(124,58,237,0.04)', flexShrink:0, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ fontSize:12, color:'var(--text2)', fontWeight:600 }}>{rdvs.length} client{rdvs.length!==1?'s':''} à rappeler</span>
              <button onClick={() => setOpen(false)} style={{ height:32, padding:'0 16px', borderRadius:100, border:'2px solid var(--border)', background:'transparent', color:'var(--text2)', fontSize:12, fontWeight:700, cursor:'pointer' }}>
                Fermer le panneau
              </button>
            </div>
          </div>
        </div>
      )}

      {detail && <DetailModal rdv={detail} onClose={() => setDetail(null)} onCall={handleCall} onDismiss={handleDismiss} />}

      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100%); opacity: 0; }
          to   { transform: translateX(0);    opacity: 1; }
        }
      `}</style>
    </>
  );
}
